import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { withBlockingRequest } from '../Application/withBlockingRequest.js'
import { addMessage } from '../../Slice/Application/ApplicationSlice.js'
import { infoMessage } from '../../../Model/Message/IMessage.js'

export const ADD_SAMPLES_UNCONFIRMED_MESSAGE =
  'Adding the samples did not complete in time. It may still be processing — the sample list will refresh.'

export const AddProjectSamplesEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.addProjectSamplesRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      const { projectId } = action.payload
      return withBlockingRequest(
        ProjectRepository.addProjectSamples(projectId, action.payload.samples).pipe(
          mergeMap((response) => of(project.addProjectSamplesRequestSuccess(response), project.loadProjectOrdersRequest({ projectId }))),
          // A gateway timeout does not stop the server, so reload rather than assume nothing was added.
          catchError((error) =>
            of(
              project.addProjectSampleRequestFailure({ error }),
              addMessage(infoMessage(ADD_SAMPLES_UNCONFIRMED_MESSAGE)),
              project.getProjectRequest({ projectId }),
              project.getProjectSamplesRequest({ projectId }),
              project.loadProjectOrdersRequest({ projectId })
            )
          )
        ),
        'Adding Samples',
        'Please wait, this operation may take longer depending on project size'
      )
    })
  )
